const trustItems = [
  { icon: "ri-shield-check-line", text: "15-Day Warranty Included" },
  { icon: "ri-star-fill", text: "5-Star Google Rated" },
  { icon: "ri-bank-card-line", text: "All Credit Types Welcome" },
  { icon: "ri-group-line", text: "Family-Owned Dealership" },
  { icon: "ri-car-line", text: "60+ Pre-Owned Vehicles" },
  { icon: "ri-money-dollar-circle-line", text: "Multiple Lender Network" },
  { icon: "ri-map-pin-line", text: "Farmington, MN Dealership" },
  { icon: "ri-thumb-up-line", text: "No Pressure Sales Process" },
  { icon: "ri-shield-check-line", text: "15-Day Warranty Included" },
  { icon: "ri-star-fill", text: "5-Star Google Rated" },
  { icon: "ri-bank-card-line", text: "All Credit Types Welcome" },
  { icon: "ri-group-line", text: "Family-Owned Dealership" },
  { icon: "ri-car-line", text: "60+ Pre-Owned Vehicles" },
  { icon: "ri-money-dollar-circle-line", text: "Multiple Lender Network" },
  { icon: "ri-map-pin-line", text: "Farmington, MN Dealership" },
  { icon: "ri-thumb-up-line", text: "No Pressure Sales Process" },
];

export default function TrustBar() {
  return (
    <section className="bg-cream-DEFAULT border-y border-cream-dark overflow-hidden py-4" aria-label="Trust indicators">
      <div className="flex animate-scroll-left w-max">
        {trustItems.map((item, i) => (
          <div
            key={i}
            className="flex items-center gap-2.5 px-8 whitespace-nowrap"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className={`${item.icon} text-gold-DEFAULT text-lg`} />
            </div>
            <span className="text-sm font-medium text-charcoal tracking-wide font-sans">
              {item.text}
            </span>
            <span className="text-gold-DEFAULT/40 ml-4 text-lg">·</span>
          </div>
        ))}
      </div>
    </section>
  );
}
